import { SxProps } from '@mui/system';

export const resultsGridStyle: SxProps = {
	marginBottom: '200px',
};
